import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { displayUserPhone } from '../../utils/staffPhone'
import {
  KycAadhaarCell,
  KycDocumentImage,
  KycMethodBadge,
  KycOtpDetails,
} from './KycTableCells'
import KycRejectReasonFields from './KycRejectReasonFields'
const $ = require("jquery")
$.Datatable = require("datatables.net");
// import "../transaction/imageview.css"


export default function UserKyc() {
  const [data, setData] = useState([])
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  
  //use for pagination..
  let [limit,setLimit] = useState(10);

  const setpageLimit = (event)=>{
    let key = event.target.value
    setLimit(key);
}
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [rejectModal, setRejectModal] = useState({
    open: false,
    id: null,
    failReasonCode: "",
    failReasonNote: "",
    submitting: false,
  });
  
  //react paginate..
  const handlePageClick = async (data) => {
      let currentPage = data.selected + 1;
      setPageNumber(currentPage);
    };

  const All = () => {

    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios.get(baseUrl+`aadharcard/all/all/all?page=${pageNumber}&_limit=${limit}`, { headers })
      .then((res) => {
        //setData(res.data)
        //$('table').dataTable();
        setData(res.data.admin)
        setNumberOfPages(res.data.totalPages)
        imageViewer();
      })
  }

  useEffect(() => {
    All()
  }, [pageNumber,limit])


  function imageViewer() {
    let imgs = document.getElementsByClassName("kyc-doc-img"),
      out = document.getElementsByClassName("img-out")[0];
    for (let i = 0; i < imgs.length; i++) {

      if (!imgs[i].classList.contains("el")) {

        imgs[i].classList.add("el");
        imgs[i].addEventListener("click", lightImage);
        function lightImage() {
          let container = document.getElementsByClassName("img-panel")[i];
          container.classList.toggle("img-panel__selct");
        };

        imgs[i].addEventListener("click", openImage);
        function openImage() {
          let imgElement = document.createElement("img"),
            imgWrapper = document.createElement("div"),
            imgClose = document.createElement("div"),
            container = document.getElementsByClassName("img-panel")[i];
          container.classList.add("img-panel__selct");
          imgElement.setAttribute("class", "image__selected");
          imgElement.src = imgs[i].src;
          imgWrapper.setAttribute("class", "img-wrapper");
          imgClose.setAttribute("class", "img-close");
          imgWrapper.appendChild(imgElement);
          imgWrapper.appendChild(imgClose);


          setTimeout(
            function () {
              imgWrapper.classList.add("img-wrapper__initial");
              imgElement.classList.add("img-selected-initial");
            }, 50);

          out.appendChild(imgWrapper);
          imgClose.addEventListener("click", function () {
            container.classList.remove("img-panel__selct");
            out.removeChild(imgWrapper);
          });
        }
      }
    }
  }


  const update = (Id) => {


    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios.patch(baseUrl+`aadharcard/${Id}`,
      { verified: "verified" },
      { headers })
      .then((res) => {
        All()
      })


  }
    const dateFormat = (e) => {
        const date = new Date(e);
        const newDate = date.toLocaleString('default', { month: 'long', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
        return newDate;
    }


  const openRejectModal = (Id) => {
    setRejectModal({
      open: true,
      id: Id,
      failReasonCode: "",
      failReasonNote: "",
      submitting: false,
    });
  };

  const closeRejectModal = () => {
    setRejectModal({
      open: false,
      id: null,
      failReasonCode: "",
      failReasonNote: "",
      submitting: false,
    });
  };

  const submitReject = () => {
    const { id, failReasonCode, failReasonNote } = rejectModal;
    if (!id) return;
    if (!failReasonCode) {
      alert("Select a reject reason for the user.");
      return;
    }
    if (failReasonCode === "other" && !failReasonNote.trim()) {
      alert("Enter a note when reason is Other.");
      return;
    }
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    setRejectModal((m) => ({ ...m, submitting: true }));
    axios
      .patch(
        baseUrl + `aadharcard/${id}`,
        {
          verified: "reject",
          failReasonCode,
          failReasonNote: failReasonNote.trim(),
        },
        { headers }
      )
      .then(() => {
        closeRejectModal();
        All();
      })
      .catch((err) => {
        alert(err.response?.data?.msg || err.message || "Reject failed");
        setRejectModal((m) => ({ ...m, submitting: false }));
      });
  };
  

  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className="row lp-kyc-page">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <div className="img-out"></div>
              <h4 className="card-title">Pending KYC</h4>
              <p className="text-muted small mb-2">
                Manual photo uploads appear here. <strong>Online OTP KYC</strong> is auto-verified — see{" "}
                <Link to="/user/kyc">Completed KYC</Link> or the user profile KYC tab.
              </p>

              <select  className="form-control col-sm-1 m-1" id='pagelimit' name='pagelimit' onChange={setpageLimit}>
                                <option value="10">Set limit</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                            </select>
              <div className="table-responsive">
                <table className="table table-hover table-sm lp-kyc-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> ID</th>
                      <th>Profile name</th>
                      <th>Method</th>
                      <th>Doc name</th>
                      <th> Phone</th>
                      <th>  Aadhar no</th>
                      <th>DOB</th>
                      <th> Document-Front</th>
                      <th> Document-Back</th>
                      <th>Online KYC details</th>
                      <th> status </th>
                      <th> Date </th>
                      <th> Approve or Reject </th>
                      {/* <th> View </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {data && data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item._id}</td>
                        <td><Link type='button' className="btn btn-primary mx-1" to={`/user/view_user/${(item.User)?item.User._id:''}`}>{(item.User) ? item.User.Name : ''}</Link></td>
                        <td><KycMethodBadge item={item} /></td>
                        <td>{item.Name}</td>
                        <td>{displayUserPhone(item.User ? item.User.Phone : '')}</td>
                        <td><KycAadhaarCell item={item} /></td>
                        <td>{item.DOB}</td>
                        <td>
                          <KycDocumentImage item={item} baseUrl={baseUrl} side="front" index={index} />
                        </td>
                        <td>
                          <KycDocumentImage item={item} baseUrl={baseUrl} side="back" index={index} />
                        </td>
                        <td style={{ minWidth: "12rem" }}>
                          <KycOtpDetails item={item} />
                        </td>
                        <td>{item.verified}</td>
                        <td>{dateFormat(item.createdAt).split(',')[0]} </td>
                        <td>
                          <button className="btn btn-success mr-1" onClick={() => update(item._id)}>Approve</button>
                          <button className="btn btn-danger" onClick={() => openRejectModal(item._id)}>Reject</button>
                        </td>
                        {/* <td><Link to="/user/view" className="btn btn-primary">View</Link></td> */}
                      </tr>

                    ))}
                  </tbody>
                </table>
              </div>
              
              <div className='mt-4'>
              <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
              />
              </div>
              
            </div>
          </div>
        </div>
      </div>

      {rejectModal.open && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reject manual KYC</h5>
                <button type="button" className="close" onClick={closeRejectModal} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <KycRejectReasonFields
                  failReasonCode={rejectModal.failReasonCode}
                  onFailReasonCodeChange={(v) =>
                    setRejectModal((m) => ({ ...m, failReasonCode: v }))
                  }
                  failReasonNote={rejectModal.failReasonNote}
                  onFailReasonNoteChange={(v) =>
                    setRejectModal((m) => ({ ...m, failReasonNote: v }))
                  }
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeRejectModal}>
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={rejectModal.submitting}
                  onClick={submitReject}
                >
                  {rejectModal.submitting ? "Rejecting…" : "Reject KYC"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
